import React from "react";
import { useFormContext } from "react-hook-form";
import SurveyFormField from "../../../../shared/components/surveyFormField/SurveyFormField";
import {
  AnimalIcon,
  ChildIcon,
  GrandParentIcon,
  PartnerIcon,
  SingleIcon,
} from "../../../../assets";
import { EMPTY_STRING } from "../../../../constants";

const FamilyMembers = () => {
  const {
    formState: { errors },
  } = useFormContext();
  const familMemberOptions = [
    {
      id: 1,
      label: "Partner",
      icon: PartnerIcon,
    },
    {
      id: 2,
      label: "Children",
      icon: ChildIcon,
    },
    {
      id: 3,
      label: "Parents",
      icon: GrandParentIcon,
    },
    {
      id: 4,
      label: "Grandparents",
      icon: GrandParentIcon,
    },
    {
      id: 5,
      label: "Animals",
      icon: AnimalIcon,
    },
    {
      id: 6,
      label: "Single",
      icon: SingleIcon,
    },
  ];
  return (
    <div>
      <div className="question-heading">Who is in your family?</div>
        {errors.familyMemberIds && (
          <div className="error">{errors.familyMemberIds.message}</div>
        )}
      <div className="form-fields">
        {familMemberOptions.map((option) => (
          <SurveyFormField
            name="familyMemberIds"
            multiple
            key={option.id}
            variant="radio"
            label={option.label}
            value={option.id}
            endAdornment={
              <div className="position-absolute marks-adornment">
                <img src={option.icon} alt={EMPTY_STRING} />
              </div>
            }
          />
        ))}
      </div>
    </div>
  );
};

export default FamilyMembers;
